var render, staticRenderFns
import script from "./InputSelect.global.vue?vue&type=script&lang=ts&"
export * from "./InputSelect.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputSelect.global.vue?vue&type=style&index=0&id=2f8b7ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b7ac4",
  null
  
)

export default component.exports